import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { EditIcon, PlusIcon, RotateIcon } from "../../icons";
import { LookupManageActionsProps } from "./LookupManageActions.types";

// Small and white with a grey border, as the list rows' own buttons are.
const actionClass =
  "btn btn-sm bg-white border text-dark fs-7 d-flex align-items-center gap-1 py-1 px-2";

/**
 * Opens a lookup's record page in a new tab, so the form being filled in is left as it
 * is, and re-reads the options once that record has been added or changed.
 */
export function LookupManageActions({
  label,
  manageRoute,
  value,
  loading,
  onRefresh,
}: LookupManageActionsProps) {
  return (
    <div className="d-flex align-items-center gap-2 flex-shrink-0">
      <a
        className={actionClass}
        href={manageRoute}
        target="_blank"
        rel="noreferrer"
        aria-label={`New ${label} in a new tab`}
      >
        <FontAwesomeIcon icon={PlusIcon} />
        New
      </a>
      {value && (
        <a
          className={actionClass}
          href={`${manageRoute}?id=${encodeURIComponent(value)}`}
          target="_blank"
          rel="noreferrer"
          aria-label={`Edit ${label} in a new tab`}
        >
          <FontAwesomeIcon icon={EditIcon} />
          Edit
        </a>
      )}
      <button
        type="button"
        className={actionClass}
        disabled={loading}
        aria-label={`Refresh ${label} options`}
        onClick={onRefresh}
      >
        <FontAwesomeIcon icon={RotateIcon} spin={loading} />
        Refresh
      </button>
    </div>
  );
}
